module.exports = __webpack_public_path__ + "static/Jira-69443417ee1440a80ff45bfce8077d7c.png";